import { AmountDisplay } from 'components/FinanceOptions/components/Options/Option/Rate/RateDetails/components';
import useOpenBankingInfo from './useOpenBankingInfo';

const OpenBankingInfo: React.FunctionComponent = function ({}) {
  const { subsidy, example, showInvalid } = useOpenBankingInfo();
  return (
    <div className="md:absolute md:bottom-8 md:right-0 md:px-4 md:py-5 md:border border-neutral-200 bg-neutral-000 rounded-lg md:shadow-popover md:min-w-80 mb-8 md:mb-0">
      <div className="grid grid-cols-[1fr_auto] gap-y-2 gap-x-2">
        {showInvalid ? (
          <>
            <p className="text-18-22-em md:text-14-22-em text-neutral-900 col-span-2 mb-2 md:mb-0">
              Open Banking Unavailable
            </p>
            <p className="text-12-18 text-neutral-600">
              Unfortunately, Open Banking is currently only available on jobs
              under £10,000
            </p>
          </>
        ) : (
          <>
            <p className="text-18-22-em md:text-14-22-em text-neutral-900 col-span-2 mb-2 md:mb-0">
              Cost Breakdown
            </p>
            <div className="border-b border-neutral-200 col-span-2" />
            <p className="text-18-22-em md:text-12-18-em text-neutral-900 col-span-2">
              Open Banking
            </p>
            <div className="border-b border-neutral-200 col-span-2" />
            <AmountDisplay title="Subsidy (1%)" amount={subsidy} />
            <div className="border-b border-neutral-200 col-span-2" />
            <p className="text-18-22-em md:text-12-18-em text-neutral-900 col-span-2">
              Card Payment Comparison
            </p>
            <div className="border-b border-neutral-200 col-span-2" />
            <AmountDisplay title="Example card fee (1.75%)" amount={example} />
            <div className="border-b border-neutral-200 col-span-2" />
            <AmountDisplay
              title="Savings to you!"
              amount={example - subsidy}
              emphasized
            />
          </>
        )}
      </div>
    </div>
  );
};

export default OpenBankingInfo;
